import {useParams} from 'react-router-dom';
import {Alert, Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useMeteringRecord} from '../hooks/useMeteringRecord.ts';

// FNP-534: read-only detail view. No edit drawer / tools — the aggregator owns the
// lifecycle. MeteringRecord is keyed on (customerId, sortKey); react-router v6
// auto-decodes each path segment, so useParams gives back the original key parts.
export const DetailPage = () => {
    const {customerId, sortKey} = useParams();

    if (typeof customerId === 'undefined' || typeof sortKey === 'undefined') {
        throw new Error('customerId and sortKey are required parameters');
    }

    const {
        record: meteringRecord,
        loading,
        isError,
        notFound,
    } = useMeteringRecord(customerId, sortKey);

    if (loading) {
        return <PlatformLoader message='Loading metering record...Please wait'/>;
    }

    // Never hang on the loader: once the query has settled, a missing record or an
    // error gets an explicit message rather than an indefinite spinner.
    if (isError || notFound || !meteringRecord) {
        return (
            <Alert color='red' title='Metering record not found'>
                No metering record found for customer <code>{customerId}</code> / <code>{sortKey}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={meteringRecord.meteringRecordId}
            pageNavigation={<EditPageNavigation component={meteringRecord}/>}
        >
            <Stack gap='lg'>
                <Profile record={meteringRecord}/>
            </Stack>
        </FormPageLayout>
    );
};
